// A versioned URL bypasses old installed web-shell icon caches after a brand update.
export const APP_ICON_SRC = '/icon-192.png?v=25'
